/**
 * Attachments strip inside the transaction-detail modal.
 *
 * Lightweight read-only list: thumbnails for images, filename + size
 * pills for everything else. Clicking opens the file in a new tab via
 * the existing `/api/attachments/:sha256` streamer.
 */
import type { EntryAttachment } from '../../api';
import { Pill } from '../../ui/primitives';

export function AttachmentsStrip({ attachments }: { attachments: EntryAttachment[] }) {
  if (attachments.length === 0) return null;
  return (
    <div>
      <h3 className="mb-2 text-small font-semibold text-ink">
        Receipts ({attachments.length})
      </h3>
      <ul className="flex flex-wrap gap-2">
        {attachments.map((a) => (
          <li key={a.id}>
            <a
              href={`/api/attachments/${a.sha256}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-md border border-border bg-surface px-2.5 py-1.5 text-small text-ink hover:border-brand/60 hover:bg-surface-raised"
              title={a.originalFilename}
            >
              {a.mimeType.startsWith('image/') ? (
                <img
                  src={`/api/attachments/${a.sha256}`}
                  alt=""
                  className="h-10 w-10 rounded object-cover"
                />
              ) : (
                <span className="inline-block rounded bg-surface-raised px-2 py-1 font-mono text-caption text-ink-muted">
                  {a.mimeType.split('/')[1] ?? 'file'}
                </span>
              )}
              <span className="max-w-[180px] truncate">{a.originalFilename}</span>
              <Pill>{(a.byteSize / 1024).toFixed(0)} kB</Pill>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
